import {getCSRContent, createP12} from '../../../commons/createCSR_p12';
import {putDataInDevCenterDataStore} from '../../../app/store';
import {getCurrentAuthType, getLoaderCloseFlag} from '../../../lhs/reducers/configuration-reducer';
import {getCredCookie, setCredCookie, storeHTTPCreds, storeJWTCreds} from '../../../commons/cookie';
import { validateP12Certficate } from '../../../libs/cybs-request-header';

var invalidateSession;

class XHConn {
  constructor() {
    var xmlhttp, bComplete = false;

    try {
      xmlhttp = new XMLHttpRequest();
    } catch (e) {
      xmlhttp = false;
    }
    if (!xmlhttp)
      return null;

    this.connect = function (requestUrl, requestMethod, sPostData, fnDone, headers, orgId, username) {
      try {
        bComplete = false;
        xmlhttp.onreadystatechange = function () {
          if (xmlhttp.readyState == 4 && !bComplete) {
            bComplete = true;
            if(!getLoaderCloseFlag()){
              fnDone(xmlhttp, orgId, username,this);
            }
          }
        };

        xmlhttp.open(requestMethod, requestUrl, true);
        xmlhttp.timeout = 120000; //2 mins timeout


        // xmlhttp.setRequestHeader("content-type", "application/json");
        if (headers) {
          // This block of code is to disable authentication for tokenize card
          headers = removeHeadersForNoAuth(headers, requestUrl, "/v1/tokens");
          for (var header in headers) {
            if (header != 'host' && header != 'date')
              xmlhttp.setRequestHeader(header, headers[header]);
          }
        }
        xmlhttp.send(sPostData);
      } catch (z) {
        //console.log(z);
        return false;
      }
      return true;
    };
    return this;
  }
}

function changeStatus(msg, status){
  putDataInDevCenterDataStore({type: 'UPDATE_SUCCESS_STATUS', successStatus: status});
  putDataInDevCenterDataStore({type: 'UPDATE_SUCCESS_MESSAGE', successMessage: msg});
}

function checkForDifferentOrg(orgId, username) {
  var existingOrgId = getCredCookie('organisationid');
  var existingUserName = getCredCookie('username');
  return (existingOrgId && (existingOrgId.toLowerCase() != orgId.toLowerCase())) || (existingUserName && (existingUserName.toLowerCase() != username.toLowerCase()));
}

function validateCredentialsAndCallKMSAPI(orgId, username, password){
  var g_xc = new XHConn();
  callKMSAPI(g_xc, orgId, username, password);
}

function getHeadersAsObject(xhr) {
  var headers = {};
  xhr.getAllResponseHeaders()
      .split('\u000d\u000a')
      .forEach(function(line) {
          if (line.length > 0) {
              var delimiter = '\u003a\u0020',
                  header = line.split(delimiter);
              headers[header.shift().toLowerCase()] = header.join(delimiter);
          }
      })
  return headers;
}

function removeHeadersForNoAuth(headers, requestUrl, url) {
  var authorizationType = getCurrentAuthType();
  if ((authorizationType == 'Json Web Token') && requestUrl.indexOf(url) > -1) {
      delete headers["authorization"];
  } else if ((authorizationType == 'HTTP Signature') && requestUrl.indexOf(url) > -1) {
      delete headers["signature"];
      delete headers["digest"];
      delete headers["v-c-merchant-id"];
      delete headers["v-c-date"];
  }
  return headers;
}

function callKMSAPI(g_xc, orgId, username, password)
{
  var currentAuthType = getCurrentAuthType();
  if(currentAuthType == "HTTP Signature")
  {
    callKMSAPIForSymKeys(g_xc, orgId, username, password);             
  }
  else
  {
    callKMSAPIForAsymKeys(g_xc, orgId, username, password);      
  }
}

var clearCredential = function(oXML)
{    
  setCredCookie('username','');
  setCredCookie('organisationid','');
  setCredCookie('csrftokenexpiry',0);
  setCredCookie('csrftoken','');
}

function invalidateSID(callback, g_xc)
{
  var apiEndPoint = "apitest.cybersource.com";
  var requestMethod = "post";
  var requestUrl = "https://" + apiEndPoint + "/vsi/logout";
   
  g_xc.connect(requestUrl, requestMethod, "", callback, null, '', '');
}

function callKMSAPIForSymKeys(g_xc, orgId, username, password)
{
  var body = "{\"clientReferenceInformation\":{\"code\":\"12345\",\"comments\":\"a comment from me\",\"partner\":{\"developerId\":\"dev1\",\"solutionId\":\"sol1\"}},\"keyInformation\":[{\"organizationId\":\"ORGID-TO-BE-REPLACED\",\"referenceNumber\":\"1000\"}]}"
  body = body.replace("ORGID-TO-BE-REPLACED",orgId);
  var headers;
  var apiEndPoint = "apitest.cybersource.com";

  var csrfToken = getCredCookie('csrftoken');


  headers = {
    "username": username,
    "password": password,
    "organizationId": orgId,
    "Content-Type": 'application/json'   
  }

   var requestMethod = "post";
   var requestUrl = "https://" + apiEndPoint + "/kms/v2/keys-sym";
   
   g_xc.connect(requestUrl, requestMethod, body, symKeyUpdate, headers, orgId, username);
}

function callKMSAPIForAsymKeys(g_xc, orgId, username, password)
{
 var body = "{\"clientReferenceInformation\":{\"code\":\"12345\",\"comments\":\"a comment from me\",\"partner\":{\"developerId\":\"dev1\",\"solutionId\":\"sol1\"}},\"keyInformation\":[{\"organizationId\":\"ORGID-TO-BE-REPLACED\",\"referenceNumber\":\"1000\",\"cert\":\"CERT-TO-BE-REPLACED\"}]}"
 body = body.replace("ORGID-TO-BE-REPLACED",orgId);
 var csrContent = getCSRContent(orgId);
 var apiEndPoint = "apitest.cybersource.com";

 if(!csrContent)
 {
    changeStatus("P12 Key generation failed due to error in CSR generation. Please try again.", "fail");
    return;
 }
 else
 {
    body = body.replace("CERT-TO-BE-REPLACED",csrContent);

    var headers;
    var csrfToken = getCredCookie('csrftoken');
  

    headers = {
      "username": username,
      "password": password,
      "organizationId": orgId,
      "Content-Type": 'application/json'
    }

    var requestMethod = "post";
    var requestUrl = "https://" + apiEndPoint + "/kms/v2/keys-asym";
    
    g_xc.connect(requestUrl, requestMethod, body, asymKeyUpdate, headers, orgId, username);
  }
}

var symKeyUpdate = function(oXML, orgId, username, g_xc) {
  var responseStatus = oXML.status;

  // check if authentication is successful. If yes, update the cookies.
  // update if csrf token changes
  var responseHeaders = getHeadersAsObject(oXML);    
  var csrfToken = responseHeaders['x-csrf-header-token'];
  if(csrfToken && (csrfToken != getCredCookie('csrftoken')))
  {
    setCredCookie('csrftokenexpiry',(new Date()).getTime() + 60*30*1000);
    setCredCookie('csrftoken',csrfToken);
    setCredCookie('organisationid', orgId);
    setCredCookie('username', username);
    
    // invalidate session after 30 min.
    clearTimeout(invalidateSession);
    invalidateSession = setTimeout(function() { invalidateSID(g_xc, clearCredential) }, 60*1000*30);
  }
  if(responseStatus == 400)
  {
    changeStatus("HTTP Key generation failed due to Missing Headers in Request. Please try again or contact Developer Center Team.", "fail");
  }
  else if(responseStatus == 401)
  {
    changeStatus("HTTP Key generation failed due to Incorrect Credentials (Organization Id, UserName or Password). Please try again with correct credentials.", "fail");
  }
  else if(responseStatus == 201)
  {
    var response = JSON.parse(oXML.responseText);
    var status = response['keyInformation'][0]['status'];
    var msg;

    if(status == 'ACTIVE')
    {
      // extract keys from response
      var apikey = response['keyInformation'][0]['keyId'];
      var sharedSecretKey = response['keyInformation'][0]['key'];
      var merchantId = response['keyInformation'][0]['organizationId'];

      // Update keys
      storeHTTPCreds(merchantId,apikey,sharedSecretKey);

      msg = "HTTP Keys generated successfully and downloaded. You are using newly generated keys."

      changeStatus(msg, "pass");
    }
    else
    {
      var details = response['keyInformation'][0]['errorInformation']['details'];
      var fields = '';
      details.forEach(function(detail) { fields = fields + detail['field'].toUpperCase() + ','});
      fields = fields.replace(/,\s*$/, "");
      fields = '[' + fields + ']';
      msg = "HTTP Key generation failed due to Missing/Invalid fields " + fields + " in the Request. Please try again or contact Developer Center Team."
      changeStatus(msg, "fail");
    }
  }
  else
  {
    changeStatus("HTTP Key generation failed due to Internal Server/System Error. Please try again or contact Developer Center Team.", "fail");
  }    
}

var asymKeyUpdate = function(oXML, orgId, username, g_xc) {
  var responseStatus = oXML.status;

  // check if authentication is successful. If yes, update the cookies.
  // update if csrf token changes
  var responseHeaders = getHeadersAsObject(oXML);    
  var csrfToken = responseHeaders['x-csrf-header-token'];
  if(csrfToken && (csrfToken != getCredCookie('csrftoken')))
  {
    setCredCookie('csrftokenexpiry',(new Date()).getTime() + 60*30*1000);
    setCredCookie('csrftoken',csrfToken);
    setCredCookie('organisationid', orgId);
    setCredCookie('username', username);
    
    // invalidate session after 30 min.
    clearTimeout(invalidateSession);
    invalidateSession = setTimeout(function() { invalidateSID(g_xc, clearCredential) }, 60*1000*30);
  }

  if(responseStatus == 400)
  {
    changeStatus("P12 Key generation failed due to Missing Headers in Request. Please try again or contact Developer Center Team.", "fail");
  }
  else if(responseStatus == 401)
  {
    changeStatus("P12 Key generation failed due to Incorrect Credentials (Organization Id, UserName or Password). Please try again with correct credentials.", "fail");
  }
  else if(responseStatus == 201)
  {
    var response = JSON.parse(oXML.responseText);
    var status = response['keyInformation'][0]['status'];
    var msg;

    if(status == 'ACTIVE')
    {
      // Call function to get p12 content
      var p12Content = createP12(response); 

      if(p12Content)
      {
        var merchantId = p12Content['merchantId'];

        //validate P12
        if(!validateP12Certficate(merchantId,p12Content['binary'], ''))
        {
          changeStatus("P12 key generation failed. Please try again.", "fail");
        }
        else
        {
          var p12b64 = p12Content['base64'];

          //Update p12
          storeJWTCreds(merchantId,p12b64);

          var msg = "P12 Key generated successfully and downloaded. You are using newly generated key."

          // Auto download keys
          var a = document.createElement('a');
          a.download = merchantId + '.p12';
          a.setAttribute('href', 'data:application/x-pkcs12;base64,' + p12b64);
          a.click();

          changeStatus(msg, "pass");
        }
      }
      else
      {
        changeStatus("P12 key generation failed. Please try again.", "fail");
      }
    }
    else
    {
      var details = response['keyInformation'][0]['errorInformation']['details'];
      var fields = '';
      details.forEach(function(detail) { fields = fields + detail['field'].toUpperCase() + ','});
      fields = fields.replace(/,\s*$/, "");
      fields = '[' + fields + ']';
      msg = "P12 Key generation failed due to Missing/Invalid fields " + fields + " in the Request. Please try again or contact Developer Center Team."
      changeStatus(msg, "fail");
    }
  }
  else
  {
    changeStatus("P12 Key generation failed due to Internal Server/System Error. Please try again or contact Developer Center Team.", "fail");
  }
}

export default validateCredentialsAndCallKMSAPI;